import * as React from 'react';
import { connect } from 'react-redux';
import { RouteComponentProps } from "react-router-dom";
import { genericMapStateToProps, IGenericUserProps } from "../../DataClasses/GenericUser";
import { createStyles, Theme } from '@mui/material/styles';;
import { withStyles, WithStyles } from '@mui/styles';;
import { Typography, Grid2 as Grid } from "@mui/material";
import BulkUploadDropzone from './BulkUploadDropzone';
import idssStyle from "../../Configuration/SharedStyling";
import { SubmissionType } from '../../DataClasses/SharedData';
import UserMessage from '../Shared/Message';
import { MessageType } from '../../DataClasses/SharedData';

const styles = (theme: Theme) => createStyles({
    ...idssStyle(theme),
    root: {
        display: 'flex',
        flexDirection: 'row',
        flexGrow: 1,
        paddingRight: theme.spacing(2)
    }
});

type IStylesProps = WithStyles<typeof styles>;

class BulkUploadView extends React.Component<IGenericUserProps & IStylesProps & RouteComponentProps<{ uploadType: SubmissionType }>> {
    public render() {
        const { classes } = this.props;
        const uploaderType: SubmissionType = this.props.match.params.uploadType;

        return (
            <div className={classes.root}>
                <Grid container={true} spacing={2} alignItems="flex-start" alignContent="flex-start">
                    <Grid size={12}>
                        <Typography variant='h4' color="inherit">
                            {this.getHeaderText(uploaderType)}
                        </Typography>
                    </Grid>
                    <Grid size={12}>
                        {this.renderByType(uploaderType)}
                    </Grid>
                </Grid>
            </div>
        );
    }

    public renderByType(uploaderType: SubmissionType) {
        const fileTypes: string[] = this.getSupportedFilesForTypes(uploaderType);
        return (
            <>
                <UserMessage text={this.getMessageContent(uploaderType)} variant={MessageType.Warning} />
                <BulkUploadDropzone user={this.props.user} uploadFileType={uploaderType} allowMultiple={true} acceptFilesOfType={fileTypes.join(',')} />
            </>
        );
    }
    private getMessageContent(uploaderType: SubmissionType) {
        const fileTypes = this.getSupportedFilesForTypes(uploaderType);
        return (
            <Typography variant='body2' color='inherit'>
                You may upload one or more submissions here at the same time. Up to 50 maximum. <br />
                All submissions must be of the following file types: {fileTypes.filter(t => t != '.zip').join(', ')}. Files can be bundled in a single zip file. The zip file can also contain nested regular folders containing files of the allowed types.<br />
                All zip/nested folders can be named as desired.<br />
                {uploaderType === SubmissionType.HEDIS || uploaderType === SubmissionType.QRS ? "Submission filenames must be of the format <<Productline>><<SubmissionId>>.xml; For ex. Commercial1234.xml" : ""}
                {uploaderType === SubmissionType.DQS ? "Submission filenames must be of the format DQResults_<<SubmissionId>>_<<YYYYMMDD>>.csv; For ex. DQResults_1010_20260520.csv" : ""}
                {uploaderType === SubmissionType.HOS ? "Submission filenames must be of the format HOS<<SubmissionId>>.txt; For ex. HOS1010.txt" : ""}
            </Typography>
        );
    }

    private getSupportedFilesForTypes(uploaderType: SubmissionType): string[] {
        switch (uploaderType) {
            case SubmissionType.HEDIS:
                return ['.xml', '.zip'];
            case SubmissionType.HOS:
                return ['.txt', '.zip'];
            case SubmissionType.CAHPS:
                return ['.csv', '.zip'];
            case SubmissionType.QRS:
                return ['.xml', '.zip'];
            case SubmissionType.DQS:
                return ['.csv', '.zip'];
            default:
                return [];
        }
    }

    private getHeaderText(uploaderType: SubmissionType): string {
        switch (uploaderType) {
            case SubmissionType.HEDIS:
                return 'HEDIS File Upload';
            case SubmissionType.HOS:
                return 'HOS File Upload';
            case SubmissionType.CAHPS:
                return 'CAHPS File Upload';
            case SubmissionType.QRS:
                return 'QRS File Upload';
            case SubmissionType.DQS:
                return 'DQS File Upload';
            default:
                return '';
        }
    }
}

// REDUX CONTAINER
const BulkUploadPageState = connect<IGenericUserProps>(genericMapStateToProps)(BulkUploadView);

// STYLES CONTAINER
const BulkUploadPage = withStyles(styles)(BulkUploadPageState);

export default BulkUploadPage;
